import { ComponentStyleConfig } from '@chakra-ui/react';

const Link: ComponentStyleConfig = {
  defaultProps: {
    variant: 'primary',
  },
  variants: {
    primary: {
      _hover: {
        textDecoration: 'none',
      },
    },
  },
};

export default Link;
